import { gql, TypedDocumentNode } from "@apollo/client";

import {
  NamedWebhooksIntegration,
  Plugin,
  QueryNamedWebhooksIntegrationArgs,
  Space,
  WebhookDelivery,
} from "types/generated";

export type GetNamedWebhookData = {
  namedWebhooksIntegration:
    | (Pick<
        NamedWebhooksIntegration,
        | "id"
        | "enabled"
        | "retryOnFailure"
        | "endpoint"
        | "name"
        | "labels"
        | "secretHeaders"
        | "createdAt"
      > & {
        space: Pick<Space, "id" | "name" | "accessLevel">;
        deliveries:
          | {
              nodes: Pick<WebhookDelivery, "id" | "status" | "timestamp">[];
              nextToken: string | null;
            }
          | null;
        plugin: Pick<Plugin, "id" | "name"> | null;
      })
    | null;
};

type GetNamedWebhookVariables = {
  id: QueryNamedWebhooksIntegrationArgs["id"];
  nextToken?: string | null;
};

export const GET_NAMED_WEBHOOK: TypedDocumentNode<GetNamedWebhookData, GetNamedWebhookVariables> = gql`
  query GetNamedWebhook($id: ID!, $nextToken: String) {
    namedWebhooksIntegration(id: $id) {
      id
      space {
        id
        name
        accessLevel
      }
      deliveries(token: $nextToken) {
        nodes {
          id
          status
          timestamp
        }
        nextToken
      }
      plugin {
        id
        name
      }
      enabled
      retryOnFailure
      endpoint
      name
      labels
      secretHeaders
      createdAt
    }
  }
`;
